import { render, staticRenderFns } from "./ServiceScheduledParticipants.vue?vue&type=template&id=24974304&scoped=true&"
import script from "./ServiceScheduledParticipants.vue?vue&type=script&lang=js&"
export * from "./ServiceScheduledParticipants.vue?vue&type=script&lang=js&"
import style0 from "./ServiceScheduledParticipants.vue?vue&type=style&index=0&id=24974304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24974304",
  null
  
)

export default component.exports